
interface ReadingProgressBarProps {
  readingProgress: number;
}

const ReadingProgressBar = ({ readingProgress }: ReadingProgressBarProps) => {
  return (
    <div 
      className="fixed top-0 left-0 h-1 bg-blue-500 z-50 transition-all duration-300" 
      style={{ width: `${readingProgress}%` }}
    />
  );
};

export default ReadingProgressBar;
